import * as ng from 'angular';
import { AsEnumerable as Enumerable } from 'linq-es5';

let themeConfig = ($mdThemingProvider: ng.material.IThemingProvider,
    $mdIconProvider: ng.material.IIconProvider, $provide:any) => {

    $mdThemingProvider.generateThemesOnDemand(true);

    $provide.value('themeProvider', $mdThemingProvider);

    $mdThemingProvider.alwaysWatchTheme(true);

};

export default ['$mdThemingProvider', '$mdIconProvider', '$provide', themeConfig];


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/theme-config.ts